import t from "../../../Common/utils/translation/translator";

/**
 * Displays IP protections more elegantly
 */
function prettyPrintIP(ips) {
  return ips.map((ip) => /(IP[0-9]+)/.exec(ip)[1]).join(", ");
}

// function prettyPrintInterfaceElement(element) {
//   const parts = element?.split(", ");
//   if (!parts || parts?.length < 2) {
//     return element;
//   }
//   switch (parts?.[0]) {
//     case "CANmotion":
//       parts[0] = t("canmotion");
//       break;
//     case "CANopen":
//       parts[0] = t("canopen");
//       break;
//     case "Modbus":
//       parts[0] = t("modbus");
//       break;
//     case "SERCOS III":
//       parts[0] = t("sercos3");
//       break;
//     case "Ethernet/IP":
//       parts[0] = t("ethernet-ip");
//       break;
//     case "EtherCAT":
//       parts[0] = t("ethercat");
//       break;
//     case "Profibus":
//       parts[0] = t("profibus");
//       break;
//     case "DeviceNet":
//       parts[0] = t("devicenet");
//       break;
//     case "I/O":
//       parts[0] = t("i-o");
//       break;
//     default:
//       break;
//   }
//   switch (parts?.[1]) {
//     case "with separated communication card":
//       parts[1] = t("with-separated-communication-card");
//       break;
//     case "integrated":
//       parts[1] = t("integrated").toLowerCase();
//       break;
//     default:
//       break;
//   }

//   return parts?.join(", ");
// }

function prettyPrintInterface(itf) {
  return itf && Object.values(itf).join(", ");
}

/**
 * Displays infomation
 */
export default function prettyPrint(col, e) {
  switch (col) {
    case "ipProtections":
      return prettyPrintIP(e);
    case "gearboxRatio":
      return `${e}:1`;
    case "motorOutputCurrent3SPeak": {
      // eslint-disable-next-line no-confusing-arrow
      const motorOC3SP = () => (e == null ? "" : `${e} ${t("msizer.ui.unit.a")} `);
      return motorOC3SP();
    }
    case "driveOutputCurrent3SPeak": {
      // eslint-disable-next-line no-confusing-arrow
      const driveOC3SP = () => (e == null ? "" : `${e} ${t("msizer.ui.unit.a")} `);
      return driveOC3SP();
    }
    case "length":
    case "flangeSize":
    case "shaftDiameter":
      return `${e} ${t("msizer.ui.unit.mm")}`;
    case "shaftLength":
      return `${e} ${t("msizer.ui.unit.mm")}`;
    case "holdingBrake":
      if (e === "Yes") {
        return t("With");
      }
      if (e === "No") {
        return t("Without");
      }
      return e;
    case "connector":
      if (e === "STRAIGHT_CONNECTORS" || e === "STRAIGHT_CONNECTOR") {
        return t("straight-connectors");
      }
      if (e === "ROTATABLE_RIGHT-ANGLED_CONNS" || e === "ROTATABLE_RH_ANGLED_CONNECTOR") {
        return t("rotatable-right-angled-connectors");
      }
      return e;
    case "nominalTorque":
    case "nominalTorqueOfMotor":
      return `${e} ${t("msizer.ui.unit.nm")}`;
    case "continuousStallTorque":
      return `${e} ${t("msizer.ui.unit.a")}`;
    case "continuousStallCurrent":
      return `${e} ${t("msizer.ui.unit.a")}`;
    case "peakStallTorque":
      return `${e} ${t("msizer.ui.unit.nm")}`;
    case "maxTorque":
      if (e) {
        return `${e} ${t("msizer.ui.unit.nm")}`;
      }
      return e;
    case "nominalSpeed":
      if (e) {
        return `${e} rpm`;
      }
      return e;
    case "nominalSpeedOfMotor":
      return `${e} ${t("msizer.ui.unit.rpm")}`;
    case "maximumMechanicalSpeed":
      return `${e} ${t("msizer.ui.unit.rpm")}`;
    case "motorSupplyVoltage":
      return `${e} ${t("msizer.ui.unit.v")}`;
    case "supplyVoltage":
      return `${e} ${t("msizer.ui.unit.v")}`;
    case "current":
      if (e) {
        return `${e} A`;
      }
      return e;
    case "gearboxType":
      if (e === "STRAIGHT_TEETH") {
        return t("straight-teeth");
      }
      return e;
    case "shaftEnd":
      if (e === "UNTAPPED") {
        return t("untapped");
      }
      if (e === "KEYED") {
        return t("keyed");
      }
      if (e === "SMOOTH") {
        return t("smooth");
      }
      return e;
    case "motorEncoder":
      if (e === "SINGLE_TURN_SINCOS_HIPERFACE") {
        return t("singleturn-sincos-hiperface");
      }
      if (e === "MULTITURN_SINCOS_HIPERFACE") {
        return t("multiturn-sincos-hiperface");
      }
      return e;
    case "interface":
      return prettyPrintInterface(e);
    case "inertia":
      if (e) {
        return `${e} ${t("msizer.ui.unit.kg_cm_squared")}`;
      }
      return e;
    case "gearboxEfficiency":
      return `${e} ${t("msizer.ui.unit.percentage")}`;
    case "gearboxTorsionalBacklash":
      return `${e} ${t("msizer.ui.unit.arc_min")}`;
    case "shaftMomentOfInertia":
      return `${e} ${t("msizer.ui.unit.kg_cm_squared")}`;
    case "gearboxNetWeight":
      return `${e} ${t("msizer.ui.unit.kg")}`;
    case "gearboxLength":
      return `${e} ${t("msizer.ui.unit.mm")}`;
    case "continuousOutputTorque":
      return `${e} ${t("msizer.ui.unit.nm")}`;
    case "maximumOutputTorque":
      return `${e} ${t("msizer.ui.unit.nm")}`;
    case "inertiaMotor":
      return `${e} ${t("msizer.ui.unit.kg_cm_squared")}`;
    case "motorWeight":
      return `${e} ${t("msizer.ui.unit.kg")}`;
    case "nominalPower":
      return `${e} ${t("msizer.ui.unit.kw")}`;
    case "outputCurrents":
      return `${e} ${t("msizer.ui.unit.a")}`;
    case "switchingFreq":
      return `${e} ${t("msizer.ui.unit.khz")}`;
    case "driveWidth":
      return `${e} ${t("msizer.ui.unit.mm")}`;
    case "driveHeight":
      return `${e} ${t("msizer.ui.unit.mm")}`;
    case "driveDepth":
      return `${e} ${t("msizer.ui.unit.mm")}`;
    case "driveNetWeight":
      return `${e} ${t("msizer.ui.unit.kg")}`;
    case "externalDiameter":
      return `${e} ${t("msizer.ui.unit.mm")}`;
    case "inputDiameter":
      return `${e} ${t("msizer.ui.unit.mm")}`;
    case "adaptationKitLength":
      return `${e} ${t("msizer.ui.unit.mm")}`;
    case "numberOfStacks":
      return `${Number(e)}`;
    case "outputCurrent3SPeak":
      return `${e} ${t("msizer.ui.unit.a")}`;
    case "lineCurrent": {
      // eslint-disable-next-line no-confusing-arrow
      const lineC = () => (e == null ? "" : `${e} ${t("msizer.ui.unit.a")} `);
      return lineC();
    }
    case "inertiaRatio":
      return `${e}`;
    default:
      return e;
  }
}
